<template>
  <div>
    <div>
      <h1 class="text-center">Booking</h1>
      <div>
        <ListBooking />
      </div>
    </div>
  </div>
</template>

<script>
import ListBooking from "@/views/Booking/ListBooking.vue";
export default {
  components: {
    ListBooking,
  },
};
</script>
